module.exports = __webpack_public_path__ + "img/campana.6b3ddfb2.svg";